import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import Practice from '@/views/Practice.vue'
import Analytics from '@/views/Analytics.vue'
import Settings from '@/views/Settings.vue'
import Profile from '@/views/Profile.vue'
import AboutView from '@/views/AboutView.vue'
import TermsView from '@/views/TermsView.vue'
import PrivacyView from '@/views/PrivacyView.vue'

const DEFAULT_TITLE = 'Curie'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { hideNavbar: true},
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresGuest: true, hideNavbar: true, title: "Login" },  // Only accessible when NOT logged in
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: { requiresGuest: true, hideNavbar: true, title: 'Register' }  // Only accessible when NOT logged in
  },
  {
    path: '/practice',
    name: 'practice',
    component: Practice,
    meta: { hideNavbar: true, title: 'Practice' }  // Accessible to guests (with daily limit) and authenticated users
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
    meta: { hideNavbar: true, title: 'Analytics' }  // Accessible to guests (with blocking modal)
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { hideNavbar: true, title: 'Settings' }  // Accessible to guests (with blocking modal)
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { hideNavbar: true, title: 'Profile' }  // Accessible to guests (with blocking modal)
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { hideNavbar: true, title: 'About' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
    meta: { hideNavbar: true, title: 'Privacy Policy' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView,
    meta: { hideNavbar: true, title: 'Terms of Service' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ==================== NAVIGATION GUARD ====================
// This runs BEFORE every route change

router.beforeEach((to, from, next) => {
  // Get token from localStorage
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token;  // Convert to boolean
  
  // Check if route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    // User is NOT logged in, but trying to access protected page
    // Redirect to login
    next('/login');
  } 
  // Check if route requires guest (login/register pages)
  else if (to.meta.requiresGuest && isAuthenticated) {
    // User IS logged in, but trying to access login/register
    // Redirect to practice page
    next('/practice');
  } 
  // All checks passed
  else {
    // Allow navigation
    next();
  }
});

router.afterEach((to) => {
  document.title = to.meta.title 
    ? `${to.meta.title} | Curie` 
    : 'Curie'
})

export default router